<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.members") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" :to="{ name: 'create-new-member' }">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <global-search-filter :queries="queries" ref="search_filter_ref" />
    <v-row no-gutters>
      <v-col cols="12" sm="2" class="toggle-spacing toggle-adjust">
        <global-toggle-filter
          :queries="toggleQueryies"
          ref="toggle_filter_ref"
          class="mt-2"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn large @click="ClearAllFilters" class="error">{{
          $t("button.reset")
        }}</v-btn>
      </v-col>
    </v-row>
    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="20"
      :loading="tableLoading"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-sm-center">
            <v-avatar size="40">
              <v-img
                @click="showImagePreview(item.main_image)"
                class="hover-pointer"
                aspect-ratio="1"
                :src="
                  item.main_image
                    ? item.main_image.path
                    : require('@/assets/imgs/user.png')
                "
              ></v-img>
            </v-avatar>
          </td>
          <td class="text-sm-center">
            {{ item.name ? item.name : "No Name Found" }}
          </td>
          <td v-if="item.user" class="text-sm-center">
            {{ item.user.firstname }} {{ item.user.lastname }}
          </td>
          <td v-else class="text-sm-center">
            <v-chip outlined text>{{ $t("table.PlzAddUser") }}</v-chip>
          </td>

          <td class="toggle-spacing text-center mx-auto">
            <div class="mx-auto" style="display: flex; justify-content: center">
              <toggle-service
                :is-edit="true"
                model-name="new-members"
                :model-id="item.id"
                field="visible"
                v-model="item.visible"
                :validate="true"
              />
            </div>
          </td>
          <td class="toggle-spacing text-center">
            <div class="mx-auto" style="display: flex; justify-content: center">
              <toggle-service
                :is-edit="true"
                model-name="new-members"
                :model-id="item.id"
                field="approved"
                v-model="item.approved"
                :validate="true"
              />
            </div>
          </td>
          <td v-if="item.user" class="toggle-spacing text-center">
            <div class="mx-auto" style="display: flex; justify-content: center">
              <toggle-service
                :is-edit="true"
                model-name="new-members"
                :model-id="item.id"
                field="creating_meeting"
                v-model="item.user.create_meeting"
                :validate="true"
              />
            </div>
          </td>
          <td v-else class="toggle-spacing text-center">
            <v-btn text class="text-capitalize"> No Access </v-btn>
          </td>
          <td class="text-sm-center">{{ item.priority }}</td>

          <td class="text-sm-center">
            <v-btn
              icon
              :to="{
                name: 'edit-new-member',
                params: { slug: item.slug },
              }"
            >
              <v-icon small title="edit"> mdi-pencil</v-icon>
            </v-btn>
            <v-icon small title="delete" @click="handleDelete(item, index)">
              mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- table -->
    <!-- Pagination -->
    <div class="text-xs-center pt-2">
      <v-pagination
        v-if="pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="handlePagination"
      ></v-pagination>
    </div>
    <!-- Image Preview -->
    <global-image-preview
      :showDialog="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
    <!-- Image Preview -->
  </div>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
export default {
  name: "Memebers",
  components: {
    // FormComponent: () => import("./formComponent"),
    // DialogComponent: () => import("@/components/DialogComponent"),
  },
  data() {
    return {
      slug: "",
      pagination: [],
      headers: [],
      items: [],
      tableLoading: true,
      dialog: false,
      isEdit: false,
      imageOverlay: false,
      currentPreviewImage: "",
      itemIndex: "",
      queries: {
        query: {
          name: "",
        },
      },
      toggleQueryies: {
        query: {
          visible: "",
        },
      },
    };
  },
  computed: {
    dialogTitle() {
      if (this.isEdit) {
        return this.$t("headings.edit");
      } else {
        return this.$t("headings.create");
      }
    },
  },

  mounted() {
    this.createTableHeaders();
  },
  methods: {
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    },
    handleUpdateImage(image) {
      this.items[this.itemIndex].main_image = image;
      this.items = [...this.items];
    },
    handleEditedMember(member) {
      this.$set(this.items, this.itemIndex, member);
    },
    handleEdit({ slug }, index) {
      this.slug = slug;
      this.itemIndex = index;
      this.dialog = true;
      this.isEdit = true;
    },
    handleDelete({ slug }, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteData({ reqName: "new-members", param: slug })
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    handleSetMember(item) {
      this.items.push(item);
    },
    createTableHeaders() {
      const headersList = [
        "profile",
        "name",
        "user",
        "visibility",
        "approved_member",
        "create_meeting",
        "priority",
        "actions",
      ];
      this.headers = TableHeaders(headersList);
    },
    handleGetMembers(query) {
      IndexData({ reqName: "new-members", query })
        .then((res) => {
          const { data } = res.data;
          this.items = data;
          this.pagination = res.data.meta;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handlePagination(page) {
      this.$router.replace({ query: { ...this.$route.query, page: page } });
    },
    showDialog() {
      this.dialog = !this.dialog;
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.isEdit = false;
        }
      },
      immediate: true,
    },
    $route: {
      handler({ query }) {
        this.handleGetMembers(query);
      },
      immediate: true,
    },
  },
};
</script>
